import { render, staticRenderFns } from "./agency-card.vue?vue&type=template&id=93651efa&scoped=true"
import script from "./agency-card.vue?vue&type=script&lang=js"
export * from "./agency-card.vue?vue&type=script&lang=js"
import style0 from "./agency-card.vue?vue&type=style&index=0&id=93651efa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93651efa",
  null
  
)

export default component.exports